import { render } from "./mvt-cardschool.vue?vue&type=template&id=f69a552c"
import script from "./mvt-cardschool.js?vue&type=script&lang=js"
export * from "./mvt-cardschool.js?vue&type=script&lang=js"

import "./mvt-cardschool.vue?vue&type=style&index=0&id=f69a552c&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__